<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <slot name="contenidoTooltip" v-bind="attrs" v-on="on">

        </slot>
      </template>
      <span>{{texto}}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'TooltipContenido',
  props:{
    texto:{
      type: String,
      default:''
    }
    
  },
  data() {
    return {
      
    }
  },
}
</script>